import { render, staticRenderFns } from "./ProductGroupings.vue?vue&type=template&id=0b4c601d&"
import script from "./ProductGroupings.vue?vue&type=script&lang=ts&"
export * from "./ProductGroupings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports